import { Badge, type BadgeTone } from "@/components/ui/badge"
import type { TicketStatus } from "@/types/ticket"

// Maps Portal::TicketPresenter status → badge tone + label. Single source
// of truth so list / detail / meta panel agree.
const STATUS_TONE: Record<TicketStatus, BadgeTone> = {
  open:             "red",
  pending:          "warning",
  closed:           "neutral",
  pending_feedback: "warning",
}

const STATUS_LABEL: Record<TicketStatus, string> = {
  open:             "Open",
  pending:          "Pending",
  closed:           "Closed",
  pending_feedback: "Awaiting feedback",
}

type Props = { status: TicketStatus }

export function TicketStatusBadge({ status }: Props) {
  return <Badge tone={STATUS_TONE[status]}>{STATUS_LABEL[status]}</Badge>
}
